import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { PatientSession } from '../models/patientSession';
import { Credentials } from '../models/credentials';
import { SignOutData } from '../models/signOutData';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  readonly #http = inject(HttpClient);

  readonly #baseUrl = '/api/Authentication';
  readonly #sessionUrl = '/api/Session';

  login(credentials: Credentials) {
    return this.#http.post<PatientSession>(`${this.#baseUrl}/Authenticate`, credentials);
  }

  loadSessionFromServer(): Observable<PatientSession> {
    return this.#http.get<PatientSession>(`${this.#sessionUrl}/GetSession`);
  }

  setSessionLanguage(languageCode: number): Observable<PatientSession> {

    return this.#http.post<PatientSession>(`${this.#sessionUrl}/Session/${languageCode}`, null);
  }

  logout() {
    return this.#http.post(`${this.#baseUrl}/SignOutWf`, {});
  }

  logoutSSO() {
    return this.#http.post<SignOutData>(`${this.#baseUrl}/SignOutAll`, {});
  }
}
